<template>
  <div>
    <a-button
      type="primary"
      @click="addWebhook('add')"
    >
      {{ $t('message["1190"]') }}Webhook
    </a-button>
    <div class="webhook-table-list">
      <a-table
        :columns="listColumns"
        :data-source="webHookList"
        :loading="listDataLoading"
        :pagination="false"
      >
        <div
          slot="name"
          slot-scope="text, record"
        >
          {{ text }}
          <p>
            <span
              class="status_tag"
              :class="{ 'stop-tag-i': !record.status }"
            >
              <span
                class="start"
              >{{ record.status ? '已启用' : '已停用' }}</span>
            </span>
          </p>
        </div>
        <div
          slot="type"
          slot-scope="text"
        >
          {{ typeName[text * 1 -1] }}
        </div>
        <div
          slot="address"
          slot-scope="text"
          class="webhook-item-address"
        >
          {{ text }}
        </div>
        <div
          slot="operate"
          slot-scope="text,record"
          class="webook-operator-box"
        >
          <a
            href="javascript:;"
            @click="editWebhook(record)"
          >{{ $t('message["36"]') }}</a>
          <a-dropdown>
            <a
              class="ant-dropdown-link"
              @click="e => e.preventDefault()"
            >
              更多
              <i class="iconfont iconicon-test19" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <router-link
                  :to="{name: 'configSendRecord', params: {hookid: record.hookid}}"
                  class="send-record-url"
                >
                  推送记录
                </router-link>
              </a-menu-item>
              <a-menu-item @click="setStopUsing(record)">
                {{ record.status ? '停用' : '启用' }}
              </a-menu-item>
              <a-menu-item
                @click="delWebhookItem(record)"
              >
                {{ $t('message["962"]') }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-table>
      <del-tip
        ref="delItemDialog"
        type="delItem"
        @operateItem="operateItem"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import DelTip from '@/components/pc/config/webhook/WebTipDialog'
export default {
  components: {
    DelTip
  },
  data () {
    return {
      delId: 0
    }
  },
  computed: {
    ...mapState('config/webhook', ['listColumns', 'typeName', 'listDataLoading']),
    ...mapGetters('config/webhook', ['webHookList']),
    comProjectName () {
      const { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      return `- ${projectname} - ${comname}`
    }
  },
  async mounted () {
    await this.getWebhookList()
    const { ListDataLoading, comProjectName } = this
    if (!ListDataLoading) {
      document.title = 'Webhook ' + comProjectName
    }
  },
  methods: {
    ...mapActions('config/webhook', ['getWebhookList', 'DelWebhook', 'setStopUsing']),
    async operateItem () {
      const chain = await this.DelWebhook({ hookid: this.delId })
      chain.onSuccess(raw => {
        this.$refs.delItemDialog.changeLimitDialog(false)
      })
        .fetch()
    },
    delWebhookItem (item) {
      this.delId = item.hookid
      this.$refs.delItemDialog.changeLimitDialog(true)
    },
    addWebhook (val) {
      this.$router.push({
        name: 'configAddWebhook',
        query: { type: 'add', hookid: 0 }
      })
    },
    editWebhook (item) {
      this.$router.push({
        name: 'configAddWebhook',
        query: { type: 'edit', hookid: item.hookid }
      })
    },
    async setStopUsingM (record) {
      await this.setStopUsing({ hookid: record.hookid })
    }
  }
}
</script>
<style lang="scss" scoped>
  .webhook-table-list::v-deep {
    margin-top: 24px;
    .send-record-url {
      margin: 0 10px;
    }
    .webhook-item-address {
      width: 440px;
      height: 24px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .webook-operator-box {
      a {
        color: #5077aa !important;
        margin-right: 10px;
      }
      .iconicon-test15 {
        font-size: 12px;
      }
    }
  }
  .status_tag {
  position: relative;
  background: #fff;
  font-size: 12px;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  padding: 2px 4px 2px 12px;
  color:#42C27E;
  font-size: 12px;
  .start::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 4px;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #b3b3b3;
  }
  .start::before {
    background: #42c27e
  }
}
.stop-tag-i {
  color:#333;
  .start::before {
    background: #e0e0e0;
  }
}
</style>
